import { ResponseSolutions } from '../types/api'
import { DataDrupal, Section, Tab, Card, Chart } from '../types/dataDrupal'

declare var window: any

const apiTabNames = ['natureBasedSolutions', 'sustainableAgriculture', 'financialInclusion', 'evaluationAndMonitoring', 'collectiveGovernance']

export const changeDataApi = (dataApi: ResponseSolutions, page: number): DataDrupal => {
  const { tabs, ...dataDrupal }: DataDrupal = window.drupalSettings.react.nodo
  const api = dataApi.data[page]
  console.log(api);
  

  // Iteracion sobre los tabs
  const solutionTabs = (CMSSolutionTabs: Tab[]): Tab[] => {
    return CMSSolutionTabs.map((CMSTab, index) => {
      return { ...CMSTab, sections: solutionSections(CMSTab.sections, apiTabNames[index]) }
    })
  }

  // Iteracion sobre las secciones
  const solutionSections = (CMSSolutionSections: Section[], tabName: string): Section[] => {
    // Dependiendo del tab se hace el ajuste de la información
    switch (tabName) {
      case 'natureBasedSolutions':
        return CMSSolutionSections.map(section => {
          return section.type !== 'cards' ? section : { ...section, cards: natureCard(section.cards) }
        })

      case 'sustainableAgriculture':
        return CMSSolutionSections.map(section => {
          return section.type !== 'charts' ? section : { ...section, charts: agricultureChart(section.charts, section.title, tabName) }
        })

      default:
        return CMSSolutionSections.map(section => {
          return section.type !== 'charts' ? section : { ...section, charts: solutionChart(section.charts, tabName) }
        })
    }
  }

  // Graficas del tab de agricultura sustentable
  const agricultureChart = (charts: Chart[] | undefined, title: string = '', tabName: string): Chart[] => {
    if (typeof charts === 'undefined') return []
    if (title === '') return charts
    let sectionName = title.toLowerCase().includes('agricultura') ? 'conservationAgriculture' : 'dripIrrigation'
    if (charts.length === 0) return charts
    return charts.map(chart => {
      if ((api as any)[tabName][sectionName].length === 0) return {...chart }
      return {
        ...chart,
        max_value: `${(api as any)[tabName][sectionName][0].projected}`,
        min_value: `${(api as any)[tabName][sectionName][0].current}`,
        title: chart.title ? `${(api as any)[tabName][sectionName][0].name}` : '',
        label: chart.label ? `${(api as any)[tabName][sectionName][1].current} ${(api as any)[tabName][sectionName][1].name}` : '',
      }
    })
  }

  // Graficas de los tabs Inclusion Financiera, Evaluacion y Monitoreo, Gobernanza Colectiva
  const solutionChart = (charts: Chart[] | undefined, tabName: string): Chart[] => {
    if (typeof charts === 'undefined') return []

    const getMaxAndMinValues = (chartInfo: any, index: number): { max_value: string, min_value: string } | undefined => {
      if (Array.isArray(chartInfo)) {
        if (chartInfo.length === 0) return
        if (chartInfo[index]) {
          return { max_value: chartInfo[index].projected, min_value: chartInfo[index].current }
        }
      }
      else if (chartInfo.hasOwnProperty('credits')) return getMaxAndMinValues(chartInfo.credits, index)
      else return
    }

    return charts.map((chart, index) => {
      return {
        ...chart,
        ...getMaxAndMinValues((api as any)[tabName], index)
      }
    })
  }


  // Tarjetas del tab Soluciones Basadas en la Naturaleza
  const natureCard = (cards: Card[] | undefined): Card[] => {
    if (typeof cards === 'undefined') return []
    return cards.map(card => {
      let el = api.natureBasedSolutions.conservationWorks.find(elemApi => elemApi.name == card.subtitle)
      if (el === undefined) return card

      return {
        ...card,
        subtitle: `${el.name}`,
        title: `${el.progressValue?.toFixed(2)} <small>${el.progressUnit}</small>`
      }
    })
  }

  // Se actualiza la información de las graficas y tarjetas de cada tab
  let nwTabs = solutionTabs(tabs)
  return { ...dataDrupal, tabs: nwTabs }
}